import React from "react";

import HospitalCard from "components/HospitalCard/HospitalCard";
import { CardContainer } from "./styled";

const TesteFetcher: React.FC = (name: any) => {
  return (
    <CardContainer>
      <HospitalCard key={0} hospitalId={name?.name} />
    </CardContainer>
  );
};

export default TesteFetcher;
